<template>
    <div>
      <form>

        <multiselect-tags
            required="true"

            :name_input_prop="'folderPermissions['+module+']['+person_permission+'][]'"
            label_multiselect="identifiable_name"
            :tags_prop="folders"
            :tags_selected_prop="selected_folders"
            index_prop="index"
            label="id"
            track-by="id"
        ></multiselect-tags>
        <hr>
        <div class="footable-editing-right">
          <button class="btn btn--blue" type="button" @click="saveFolders()">Save</button>
        </div>
      </form>
    </div>

</template>

<script>

export default {

    mounted() {

    },
    data () {
        return {

        }
    },
    methods: {

      saveFolders(){
        axios.put("/permission-folder-person-save-folders/folder_visibility_for_person/"+this.person_permission,{
          form_data : $("form").serialize(),
          _token  : this.csrf_token
        }).then((response) => {
          app.__vue__.$refs.vue_popup.active = false;
          Vue.$toast.open({
            message: 'Save Complete!',
            type: 'success',
            position: 'top-right'
          });

        }).catch(function(error){
          alert(error);
        });
      },

    },
    props: {
        module : {
          required : true,
          type : Number
        },
        person_permission : {
          required : true,
          type : Number
        },
        folders : {
          required : true,
          type : Array
        },
        selected_folders : {
          required : true,
          type : Array
        },
        csrf_token : {
          required : true,
          type : String
        },
    }
}
</script>

<style>
</style>
